/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Status of the fee
 */
export type FeeEntryStatus = typeof FeeEntryStatus[keyof typeof FeeEntryStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeeEntryStatus = {
  pending: 'pending',
  posted: 'posted',
  void: 'void',
} as const;
